var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserLoginImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_4_",
    style: {
      fill: "#F0F0F0"
    },
    cx: 249.048,
    cy: 350.024,
    rx: 235.608,
    ry: 136.029
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shadow_43_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M384.363,397.224c-15.45-8.92-15.45-23.382,0-32.302 c15.45-8.92,40.498-8.92,55.948,0c15.45,8.92,15.45,23.382,0,32.302C424.861,406.144,399.813,406.144,384.363,397.224z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shadow_4_",
    style: {
      fill: "#E0E0E0"
    },
    d: "M70.119,398.462l-40.64-23.464c-2.291-1.323-2.291-3.468,0-4.791l236.389-136.479 c2.291-1.323,6.006-1.323,8.297,0l40.642,23.463c2.291,1.323,2.291,3.468,0,4.79L78.416,398.462 C76.125,399.785,72.41,399.785,70.119,398.462z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Device"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Device_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1341_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1346_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1347_",
    style: {
      fill: "#27DEBF"
    },
    d: "M216.2,356.644l34.937-20.201c3.601-2.079,5.402-4.804,5.402-7.529 c0-2.725,0.015-4.86,0.015-4.86l-36.249-20.44c-1.921-1.109-3.478-3.806-3.478-6.024v-43.075l-61.023,35.262l-0.002,43.074 c0,2.218,1.557,4.915,3.478,6.024l30.836,17.768C197.319,360.803,208.997,360.802,216.2,356.644z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1608_",
    style: {
      opacity: 0.6
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1609_",
    d: "M216.2,356.644l34.937-20.201c3.601-2.079,5.402-4.804,5.402-7.529c0-2.725,0.015-4.86,0.015-4.86 l-36.249-20.44c-1.921-1.109-3.478-3.806-3.478-6.024v-43.075l-61.023,35.262l-0.002,43.074c0,2.218,1.557,4.915,3.478,6.024 l30.836,17.768C197.319,360.803,208.997,360.802,216.2,356.644z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1345_",
    style: {
      opacity: 0.3
    },
    d: "M170.455,340.48v4.839l-11.184-6.445c-1.908-1.104-3.474-3.795-3.474-6.024 v-43.07l11.626-6.707c0.241,2.952,0.502,6.004,0.743,8.976l-8.152,4.719v33.653c0,2.229,1.546,4.919,3.474,6.024L170.455,340.48z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1344_",
    style: {
      fill: "#27DEBF"
    },
    d: "M160.012,330.428c0,2.218,1.557,4.915,3.478,6.024l26.622,15.335 c7.203,4.158,18.882,4.16,26.085,0.003l34.955-20.199c7.204-4.157,7.205-10.898,0.002-15.057l-26.639-15.345 c-1.921-1.109-3.478-3.806-3.478-6.024l-0.001-33.657l-61.024,35.262V330.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1607_",
    style: {
      opacity: 0.3
    },
    d: "M160.012,330.428c0,2.218,1.557,4.915,3.478,6.024l26.622,15.335 c7.203,4.158,18.882,4.16,26.085,0.003l34.955-20.199c7.204-4.157,7.205-10.898,0.002-15.057l-26.639-15.345 c-1.921-1.109-3.478-3.806-3.478-6.024l-0.001-33.657l-61.024,35.262V330.428z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1343_",
    style: {
      opacity: 0.5
    },
    d: "M231.598,305.283v-0.005l-7.084-4.09c-1.921-1.109-3.478-3.806-3.478-6.024 l0-33.657l-61.025,35.262v33.659c0,2.218,1.557,4.915,3.478,6.024l6.961,4.019L231.598,305.283z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1342_",
    style: {
      fill: "#27DEBF"
    },
    d: "M256.548,324.058c0,0,0,2.128,0,4.859c0,2.731-1.807,5.441-5.401,7.53 l-34.943,20.189c-3.454,2.008-7.931,3.012-12.449,3.092v-4.839c4.518-0.06,8.995-1.104,12.449-3.092l34.943-20.21 C254.74,329.519,256.548,326.789,256.548,324.058z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1610_",
    style: {
      opacity: 0.5
    },
    d: "M256.548,324.058c0,0,0,2.128,0,4.859c0,2.731-1.807,5.441-5.401,7.53 l-34.943,20.189c-3.454,2.008-7.931,3.012-12.449,3.092v-4.839c4.518-0.06,8.995-1.104,12.449-3.092l34.943-20.21 C254.74,329.519,256.548,326.789,256.548,324.058z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1340_",
    style: {
      fill: "#27DEBF"
    },
    d: "M62.031,372.263c2.252,1.3,6.025,1.23,8.426-0.156 c30.001-17.321,206-118.932,235.997-136.25c2.401-1.386,4.346-4.757,4.346-7.529V37.414c0-2.772-1.826-6.074-4.078-7.374 c-2.252-1.3-6.024-1.231-8.425,0.156L62.303,166.446c-2.401,1.386-4.347,4.757-4.347,7.53l-0.003,190.913 C57.953,367.661,59.778,370.962,62.031,372.263z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1339_",
    style: {
      fill: "#27DEBF"
    },
    d: "M70.457,372.102l235.996-136.249c2.401-1.386,4.347-4.757,4.347-7.53V37.409 c0-2.772-1.946-3.896-4.347-2.51L70.46,171.149c-2.401,1.386-4.347,4.757-4.347,7.53L66.11,369.592 C66.11,372.364,68.057,373.488,70.457,372.102z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1338_",
    style: {
      opacity: 0.5
    },
    d: "M70.457,372.102l235.996-136.249c2.401-1.386,4.347-4.757,4.347-7.53V37.409 c0-2.772-1.946-3.896-4.347-2.51L70.46,171.149c-2.401,1.386-4.347,4.757-4.347,7.53L66.11,369.592 C66.11,372.364,68.057,373.488,70.457,372.102z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1337_",
    style: {
      fill: "#27DEBF"
    },
    d: "M69.817,377.064c-2.409,1.064-5.742,1.024-7.79-0.161 c-2.249-1.305-4.076-4.598-4.076-7.389v-17.383l8.152,4.719v17.383C66.103,376.763,67.709,377.907,69.817,377.064z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1606_",
    style: {
      opacity: 0.5
    },
    d: "M69.817,377.064c-2.409,1.064-5.742,1.024-7.79-0.161 c-2.249-1.305-4.076-4.598-4.076-7.389v-17.383l8.152,4.719v17.383C66.103,376.763,67.709,377.907,69.817,377.064z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1336_",
    style: {
      fill: "#27DEBF"
    },
    d: "M66.103,356.849l0.007,17.377c0,2.772,1.947,3.896,4.347,2.51l235.996-136.249 c2.401-1.386,4.347-4.757,4.347-7.53v-17.414L66.103,356.849z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1335_",
    style: {
      opacity: 0.3
    },
    d: "M66.11,356.813l0,17.413c0,2.772,1.947,3.896,4.347,2.51l235.996-136.249 c2.401-1.386,4.347-4.757,4.347-7.53v-17.414L66.11,356.813z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1334_",
    style: {
      fill: "#27DEBF"
    },
    d: "M74.264,335.041l0.002-153.655c0-1.663,1.168-3.686,2.608-4.518L300.031,48.028 c1.441-0.832,2.608-0.157,2.608,1.506l0.007,153.659c0,1.663-1.168,3.686-2.608,4.518L76.873,336.547 C75.432,337.379,74.264,336.704,74.264,335.041z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1333_",
    style: {
      fill: "#263238"
    },
    d: "M74.264,335.041l0.002-153.655c0-1.663,1.168-3.686,2.608-4.518L300.031,48.028 c1.441-0.832,2.608-0.157,2.608,1.506l0.007,153.659c0,1.663-1.168,3.686-2.608,4.518L76.873,336.547 C75.432,337.379,74.264,336.704,74.264,335.041z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1332_",
    style: {
      fill: "#27DEBF"
    },
    d: "M188.452,291.726c-2.253,1.301-4.079,4.464-4.079,7.065 c0,2.601,1.827,3.655,4.08,2.354c2.253-1.301,4.079-4.464,4.079-7.065C192.531,291.48,190.705,290.426,188.452,291.726z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1331_",
    style: {
      opacity: 0.7
    },
    d: "M67.388,174.378c-0.783,1.365-1.265,2.911-1.285,4.297v178.175l-8.152-4.719 l0.005-178.155c0-1.385,0.497-2.931,1.28-4.296L67.388,174.378z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1544_",
    style: {
      opacity: 0.3
    },
    d: "M310.756,36.694c-0.308-2.241-2.118-3.053-4.307-1.799L70.46,171.153 c-1.193,0.689-2.272,1.861-3.074,3.228l-8.153-4.708c0.792-1.347,1.871-2.539,3.074-3.228L298.296,30.197 c2.406-1.388,6.168-1.46,8.43-0.154C308.782,31.225,310.478,34.093,310.756,36.694z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Window_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Window_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1920_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#27DEBF"
    },
    d: "M323.492,60.187c-0.568-0.341-1.343-0.329-2.217,0.176L98.587,188.949 c-1.683,0.972-3.047,3.332-3.047,5.275l0.002,152.719c0,1.184,0.507,2.23,1.284,2.647c0.498,0.268,3.115,1.79,3.892,2.208 c0.498,0.268,1.107,0.277,1.765-0.102l222.68-128.637c1.684-0.969,3.049-3.329,3.049-5.272V64.328 c0-1.002-0.363-1.696-0.944-2.001C326.721,62.041,324.053,60.523,323.492,60.187z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1917_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1919_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAFAFA"
    },
    d: "M101.477,351.491c-0.851,0-1.542-1.05-1.542-2.34V196.432c0-1.75,1.28-3.968,2.796-4.844 L325.416,63.002c0.396-0.229,0.779-0.349,1.11-0.349c0.743,0,1.186,0.626,1.186,1.675v153.46c0,1.75-1.281,3.966-2.798,4.838 L102.233,351.263C101.971,351.414,101.717,351.491,101.477,351.491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M326.527,63.153L326.527,63.153c0.596,0,0.685,0.736,0.685,1.175v153.46 c0,1.593-1.167,3.61-2.549,4.406L101.985,350.83c-0.186,0.107-0.357,0.161-0.508,0.161c-0.556,0-1.043-0.86-1.043-1.84 V196.432c0-1.594,1.166-3.613,2.546-4.41L325.666,63.435C326.07,63.202,326.357,63.153,326.527,63.153 M326.527,62.153 c-0.409,0-0.872,0.134-1.361,0.416L102.481,191.156c-1.682,0.971-3.046,3.334-3.046,5.276v152.719 c0,1.536,0.853,2.84,2.043,2.84c0.315,0,0.654-0.091,1.006-0.294l222.68-128.637c1.684-0.969,3.049-3.329,3.049-5.272V64.328 C328.213,62.95,327.526,62.153,326.527,62.153L326.527,62.153z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1918_",
    style: {
      fill: "#F0F0F0"
    },
    d: "M96.822,349.589c0.33,0.175,2.699,1.526,3.737,2.117 c-0.7-0.499-1.069-1.356-1.121-2.558V206.397l-3.9-2.282v142.829C95.538,348.123,96.046,349.177,96.822,349.589z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1913_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1916_",
    style: {
      fill: "#27DEBF"
    },
    d: "M328.211,64.305c-0.012-1.924-1.369-2.703-3.044-1.736L102.481,191.156 c-1.682,0.971-3.046,3.334-3.046,5.276l0.003,9.965L328.211,74.303V64.305z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1915_",
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325.165,62.568L102.484,191.154c-0.834,0.489-1.6,1.313-2.146,2.261l-3.871-2.242 c0.546-0.939,1.296-1.755,2.119-2.225L321.275,60.362c0.872-0.508,1.648-0.516,2.214-0.18 c0.546,0.335,3.076,1.773,3.718,2.117C326.669,62.041,325.951,62.118,325.165,62.568z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1914_",
    style: {
      opacity: 0.15
    },
    d: "M95.538,204.125l0.002-9.905c0-0.987,0.362-2.079,0.927-3.047l3.88,2.232 c-0.565,0.958-0.91,2.041-0.91,3.027v9.963L95.538,204.125z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_985_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_639_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_645_",
    style: {
      fill: "#27DEBF"
    },
    d: "M281.25,179.423l-133.374,77.003c-1.229,0.71-2.226,2.436-2.226,3.855v38.236 c0,1.419,0.997,3.144,2.228,3.852l3.897,2.242c1.23,0.708,3.224,0.706,4.453-0.003l133.356-76.993 c1.229-0.71,2.226-2.436,2.227-3.855l0.016-38.247c0.001-1.419-0.996-3.144-2.227-3.852l-3.896-2.242 C284.473,178.712,282.479,178.714,281.25,179.423z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_717_",
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M291.809,185.153c-0.154-1.151-1.09-1.573-2.21-0.925 L156.23,261.229c-0.617,0.35-1.172,0.966-1.573,1.665l-8.348-4.822c0.401-0.689,0.956-1.295,1.563-1.645l133.379-77.001 c1.224-0.709,3.218-0.72,4.452-0.01l3.896,2.241C290.729,182.305,291.665,183.817,291.809,185.153z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_730_",
    style: {
      fill: "#263238"
    },
    d: "M155.85,304.787c-1.234,0.524-2.961,0.463-4.071-0.175l-3.896-2.241 c-1.234-0.709-2.231-2.436-2.231-3.855v-38.233c0-0.72,0.257-1.511,0.658-2.21l8.348,4.822c-0.411,0.699-0.658,1.48-0.658,2.19 v38.243C153.999,304.602,154.801,305.188,155.85,304.787z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_644_",
    style: {
      fill: "#27DEBF"
    },
    d: "M156.227,261.233l133.374-77.004c1.229-0.71,2.225-0.134,2.225,1.285 l-0.016,38.247c-0.001,1.419-0.998,3.145-2.227,3.855l-133.356,76.993c-1.229,0.71-2.226,0.134-2.226-1.285v-38.236 C154.002,263.668,154.998,261.942,156.227,261.233z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_647_",
    style: {
      fill: "#455A64"
    },
    d: "M245.894,199.839l-98.023,56.589c-0.606,0.35-1.161,0.956-1.563,1.645 l8.348,4.822c0.401-0.699,0.956-1.316,1.573-1.665l97.997-56.579L245.894,199.839z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_652_",
    style: {
      fill: "#37474F"
    },
    d: "M254.227,204.652l-98,56.58c-1.229,0.71-2.226,2.436-2.226,3.855v38.236 c0,1.419,0.996,1.995,2.226,1.285l98-56.58V204.652z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_640_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1663_",
    style: {
      fill: "#27DEBF"
    },
    d: "M178.829,256.575l50.567-29.196c2.097-1.211,3.796-0.351,3.796,1.921 c0,2.271-1.7,5.094-3.797,6.305l-50.563,29.193c-2.097,1.211-3.798,0.351-3.798-1.919 C175.033,260.608,176.732,257.786,178.829,256.575z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_646_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_986_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M189.191,266.237c0.057-0.033,0.107-0.024,0.148,0.026 c0.042,0.05,0.063,0.125,0.063,0.227v5.695c0,0.574-0.047,1.118-0.142,1.636c-0.092,0.516-0.233,0.996-0.422,1.438 c-0.187,0.442-0.422,0.833-0.702,1.177c-0.282,0.342-0.607,0.62-0.977,0.833c-0.375,0.217-0.703,0.315-0.981,0.297 c-0.279-0.02-0.512-0.143-0.699-0.367c-0.188-0.225-0.327-0.544-0.419-0.954c-0.09-0.41-0.137-0.902-0.137-1.476v-5.694 c0-0.102,0.021-0.201,0.063-0.299c0.041-0.098,0.09-0.165,0.148-0.197l0.634-0.366c0.057-0.034,0.106-0.025,0.149,0.025 c0.041,0.05,0.062,0.125,0.062,0.227v5.625c0,0.38,0.029,0.687,0.086,0.922c0.056,0.237,0.138,0.41,0.241,0.52 c0.104,0.112,0.23,0.165,0.376,0.16c0.146-0.006,0.305-0.059,0.477-0.158c0.172-0.099,0.331-0.231,0.48-0.396 c0.149-0.165,0.275-0.361,0.38-0.594c0.104-0.231,0.186-0.498,0.246-0.801c0.06-0.303,0.089-0.645,0.089-1.024v-5.624 c0-0.102,0.021-0.201,0.062-0.299c0.042-0.098,0.091-0.165,0.15-0.198L189.191,266.237z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_988_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M193.113,271.625c0-0.1-0.018-0.174-0.055-0.218 c-0.036-0.044-0.1-0.067-0.191-0.07c-0.091-0.003-0.213,0.011-0.363,0.043c-0.152,0.032-0.344,0.069-0.578,0.112 c-0.23,0.04-0.419,0.032-0.57-0.018c-0.152-0.052-0.272-0.145-0.363-0.277c-0.091-0.133-0.155-0.305-0.192-0.522 c-0.036-0.215-0.054-0.461-0.054-0.738c0-0.278,0.036-0.572,0.109-0.884c0.073-0.31,0.178-0.609,0.316-0.897 c0.139-0.288,0.306-0.554,0.504-0.798c0.198-0.243,0.425-0.439,0.68-0.586c0.255-0.147,0.483-0.229,0.684-0.241 c0.201-0.015,0.371,0.021,0.512,0.106c0.14,0.086,0.249,0.215,0.327,0.388c0.078,0.173,0.122,0.366,0.133,0.582 c0.005,0.099-0.015,0.199-0.059,0.298s-0.095,0.166-0.153,0.198l-0.601,0.347c-0.077,0.045-0.137,0.054-0.176,0.026 c-0.039-0.028-0.081-0.062-0.128-0.1c-0.047-0.036-0.109-0.058-0.188-0.064c-0.077-0.006-0.195,0.036-0.351,0.126 c-0.157,0.09-0.294,0.211-0.414,0.363c-0.12,0.153-0.181,0.336-0.181,0.549c0,0.101,0.015,0.178,0.044,0.232 c0.028,0.052,0.082,0.084,0.163,0.092c0.081,0.01,0.194,0.002,0.337-0.02c0.143-0.022,0.328-0.058,0.558-0.106 c0.463-0.092,0.79-0.006,0.98,0.259c0.19,0.265,0.286,0.677,0.286,1.231c0,0.279-0.039,0.571-0.117,0.88 c-0.078,0.309-0.192,0.61-0.34,0.905c-0.149,0.294-0.33,0.566-0.547,0.816c-0.216,0.25-0.46,0.453-0.73,0.608 c-0.277,0.16-0.519,0.242-0.731,0.248c-0.211,0.006-0.39-0.041-0.534-0.143c-0.147-0.1-0.258-0.244-0.336-0.431 c-0.078-0.186-0.12-0.388-0.126-0.607c-0.005-0.099,0.015-0.199,0.059-0.298c0.044-0.099,0.094-0.166,0.152-0.2l0.602-0.347 c0.078-0.044,0.136-0.046,0.176-0.004c0.038,0.043,0.083,0.09,0.132,0.146c0.049,0.055,0.118,0.089,0.207,0.103 c0.088,0.013,0.221-0.031,0.399-0.134c0.078-0.045,0.159-0.101,0.242-0.168c0.083-0.066,0.161-0.141,0.231-0.223 c0.069-0.082,0.128-0.172,0.176-0.268C193.089,271.826,193.113,271.727,193.113,271.625z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_990_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M195.15,268.906c0-0.518,0.044-1.031,0.133-1.541 c0.089-0.509,0.217-0.981,0.383-1.416c0.167-0.434,0.368-0.816,0.605-1.148c0.237-0.331,0.501-0.58,0.793-0.749 c0.291-0.169,0.555-0.227,0.793-0.175c0.236,0.054,0.438,0.193,0.605,0.416c0.166,0.223,0.295,0.524,0.387,0.901 c0.09,0.379,0.137,0.804,0.137,1.276v0.624c0,0.102-0.021,0.203-0.063,0.299c-0.041,0.098-0.09,0.165-0.149,0.198l-2.609,1.507 c0,0.213,0.026,0.385,0.075,0.518c0.049,0.135,0.115,0.233,0.199,0.295c0.083,0.063,0.18,0.091,0.289,0.083 c0.109-0.007,0.222-0.045,0.336-0.111c0.166-0.095,0.301-0.203,0.406-0.324c0.104-0.12,0.19-0.245,0.258-0.378 c0.057-0.106,0.104-0.185,0.141-0.234c0.036-0.049,0.086-0.09,0.149-0.126l0.625-0.361c0.056-0.032,0.107-0.025,0.152,0.022 c0.044,0.049,0.064,0.126,0.058,0.231c-0.005,0.133-0.045,0.322-0.12,0.57c-0.075,0.247-0.189,0.511-0.34,0.793 c-0.151,0.282-0.337,0.556-0.558,0.822c-0.221,0.266-0.478,0.484-0.769,0.652c-0.292,0.169-0.556,0.231-0.793,0.189 c-0.237-0.044-0.439-0.185-0.605-0.422c-0.167-0.237-0.294-0.559-0.383-0.967C195.195,269.944,195.15,269.462,195.15,268.906z  M197.065,265.717c-0.152,0.088-0.28,0.203-0.387,0.342c-0.107,0.142-0.197,0.294-0.27,0.461 c-0.073,0.168-0.128,0.338-0.168,0.514c-0.039,0.176-0.064,0.335-0.075,0.48l1.766-1.019c-0.01-0.132-0.03-0.266-0.058-0.404 c-0.028-0.136-0.075-0.247-0.141-0.335c-0.065-0.086-0.152-0.138-0.258-0.156C197.367,265.583,197.231,265.622,197.065,265.717z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1008_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M202.127,262.934c-0.312,0.181-0.537,0.434-0.676,0.758 c-0.138,0.326-0.207,0.766-0.207,1.321v3.611c0,0.101-0.021,0.202-0.062,0.299c-0.042,0.098-0.091,0.165-0.15,0.197 l-0.592,0.343c-0.057,0.032-0.107,0.024-0.149-0.026c-0.042-0.049-0.063-0.125-0.063-0.227v-6.472 c0-0.101,0.021-0.202,0.063-0.299c0.041-0.098,0.091-0.164,0.149-0.198l0.592-0.341c0.058-0.034,0.107-0.025,0.15,0.025 c0.041,0.049,0.062,0.125,0.062,0.227v0.32c0.135-0.301,0.28-0.555,0.434-0.765c0.153-0.209,0.354-0.385,0.605-0.53l0.351-0.203 c0.057-0.032,0.106-0.024,0.149,0.026c0.041,0.049,0.062,0.126,0.062,0.227v0.917c0,0.102-0.021,0.202-0.062,0.3 c-0.042,0.098-0.091,0.165-0.149,0.197L202.127,262.934z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1013_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M209.587,262.447c0.057-0.033,0.106-0.024,0.149,0.026 c0.041,0.049,0.062,0.126,0.062,0.227v0.987c0,0.101-0.021,0.202-0.062,0.299c-0.042,0.098-0.091,0.164-0.149,0.197 l-3.422,1.976c-0.058,0.033-0.106,0.024-0.149-0.026c-0.041-0.049-0.062-0.125-0.062-0.227v-8.972 c0-0.101,0.021-0.201,0.062-0.299c0.042-0.098,0.09-0.164,0.149-0.197l0.633-0.365c0.057-0.033,0.107-0.024,0.149,0.026 c0.042,0.05,0.063,0.124,0.063,0.227v7.61L209.587,262.447z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1017_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M212.656,255.05c0.287-0.166,0.546-0.237,0.778-0.213 c0.232,0.023,0.433,0.125,0.601,0.305c0.17,0.18,0.305,0.425,0.406,0.738c0.102,0.311,0.162,0.676,0.177,1.092 c0.005,0.08,0.008,0.185,0.008,0.315c0,0.128,0,0.259,0,0.387c0,0.131,0,0.257,0,0.384c0,0.124-0.003,0.23-0.008,0.316 c-0.021,0.438-0.08,0.87-0.18,1.298c-0.099,0.428-0.233,0.827-0.403,1.198c-0.169,0.37-0.37,0.702-0.601,0.993 c-0.232,0.291-0.491,0.519-0.778,0.685c-0.286,0.165-0.545,0.237-0.777,0.213c-0.231-0.024-0.432-0.122-0.6-0.299 c-0.17-0.175-0.304-0.42-0.403-0.732c-0.099-0.313-0.16-0.678-0.181-1.091c-0.005-0.08-0.008-0.183-0.011-0.305 c-0.002-0.125-0.004-0.249-0.004-0.379c0-0.131,0.002-0.261,0.004-0.392c0.003-0.131,0.006-0.239,0.011-0.325 c0.016-0.436,0.075-0.867,0.176-1.297c0.102-0.429,0.238-0.831,0.408-1.207c0.169-0.376,0.369-0.708,0.6-0.999 C212.111,255.443,212.37,255.216,212.656,255.05z M213.603,257.629c-0.016-0.278-0.054-0.494-0.115-0.65 c-0.06-0.155-0.133-0.263-0.223-0.323c-0.088-0.06-0.184-0.08-0.288-0.062c-0.104,0.018-0.212,0.059-0.321,0.122 c-0.108,0.062-0.215,0.146-0.319,0.248c-0.104,0.101-0.201,0.234-0.289,0.396c-0.088,0.163-0.164,0.356-0.223,0.58 c-0.059,0.224-0.097,0.485-0.113,0.78c-0.005,0.078-0.009,0.173-0.011,0.285c-0.003,0.112-0.005,0.229-0.005,0.349 c0,0.12,0.002,0.237,0.005,0.351c0.002,0.115,0.006,0.203,0.011,0.265c0.016,0.277,0.054,0.494,0.113,0.648 c0.059,0.156,0.135,0.263,0.223,0.323c0.088,0.06,0.185,0.081,0.289,0.062c0.104-0.018,0.211-0.06,0.319-0.122 c0.109-0.063,0.217-0.145,0.321-0.247c0.104-0.102,0.2-0.233,0.288-0.396c0.089-0.163,0.163-0.356,0.223-0.58 c0.06-0.225,0.098-0.485,0.115-0.781c0.004-0.066,0.007-0.159,0.007-0.275c0-0.116,0-0.235,0-0.355c0-0.118,0-0.235,0-0.345 C213.61,257.79,213.607,257.7,213.603,257.629z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1020_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M217.679,260.898c0.111-0.062,0.222-0.158,0.337-0.284 c0.114-0.126,0.218-0.28,0.311-0.465c0.094-0.183,0.171-0.392,0.231-0.626c0.06-0.234,0.09-0.485,0.09-0.754v-0.514 c-0.042,0.107-0.096,0.229-0.165,0.365c-0.067,0.137-0.15,0.275-0.246,0.414c-0.096,0.139-0.209,0.273-0.335,0.402 c-0.128,0.131-0.273,0.241-0.434,0.333c-0.261,0.151-0.497,0.197-0.707,0.139c-0.212-0.058-0.391-0.197-0.539-0.412 c-0.149-0.215-0.266-0.494-0.351-0.838c-0.086-0.344-0.135-0.726-0.146-1.146c-0.005-0.137-0.007-0.296-0.007-0.482 c0-0.185,0.002-0.347,0.007-0.49c0.011-0.432,0.059-0.869,0.146-1.313c0.085-0.443,0.203-0.857,0.351-1.244 c0.149-0.387,0.327-0.732,0.539-1.034c0.21-0.302,0.446-0.527,0.707-0.678c0.161-0.093,0.306-0.151,0.434-0.168 c0.126-0.018,0.239-0.013,0.335,0.014c0.096,0.027,0.179,0.071,0.246,0.13c0.068,0.058,0.122,0.117,0.165,0.176v-0.32 c0-0.101,0.02-0.201,0.062-0.299c0.041-0.098,0.09-0.164,0.149-0.197l0.593-0.343c0.057-0.032,0.107-0.024,0.149,0.026 c0.042,0.049,0.063,0.126,0.063,0.227v6.514c0,1.12-0.177,2.066-0.528,2.839c-0.351,0.773-0.837,1.337-1.458,1.695 c-0.265,0.154-0.511,0.233-0.738,0.24c-0.226,0.005-0.423-0.048-0.589-0.16c-0.167-0.112-0.299-0.272-0.399-0.479 c-0.098-0.207-0.154-0.447-0.164-0.718c-0.006-0.098,0.014-0.198,0.059-0.297c0.043-0.1,0.094-0.167,0.152-0.2l0.531-0.306 c0.073-0.042,0.135-0.034,0.187,0.024c0.052,0.057,0.097,0.112,0.133,0.167c0.067,0.118,0.16,0.195,0.277,0.228 C217.247,261.099,217.43,261.043,217.679,260.898z M216.742,256.051c-0.016,0.269-0.016,0.528,0,0.779 c0.031,0.582,0.136,0.956,0.313,1.116c0.176,0.163,0.393,0.169,0.647,0.022c0.255-0.148,0.47-0.406,0.645-0.775 c0.175-0.368,0.275-0.811,0.301-1.326c0.01-0.145,0.016-0.323,0.016-0.537c0-0.213-0.006-0.385-0.016-0.518 c-0.026-0.467-0.126-0.788-0.301-0.966c-0.175-0.177-0.39-0.192-0.645-0.044c-0.255,0.146-0.472,0.405-0.647,0.771 C216.878,254.939,216.774,255.433,216.742,256.051z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1023_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M221.976,247.17c0.057-0.034,0.107-0.025,0.148,0.024 c0.042,0.05,0.063,0.127,0.063,0.228v1.083c0,0.102-0.021,0.202-0.063,0.3c-0.041,0.098-0.091,0.164-0.148,0.198l-0.671,0.387 c-0.057,0.032-0.107,0.024-0.149-0.026c-0.042-0.05-0.063-0.126-0.063-0.228v-1.083c0-0.101,0.021-0.202,0.063-0.3 c0.041-0.097,0.091-0.164,0.149-0.196L221.976,247.17z M222.149,256.555c0,0.102-0.021,0.203-0.063,0.299 c-0.041,0.098-0.091,0.165-0.149,0.198l-0.592,0.342c-0.057,0.033-0.107,0.024-0.149-0.026 c-0.042-0.048-0.063-0.125-0.063-0.227v-6.471c0-0.102,0.021-0.203,0.063-0.299c0.041-0.098,0.091-0.165,0.149-0.198 l0.592-0.342c0.057-0.033,0.107-0.024,0.149,0.026c0.042,0.048,0.063,0.124,0.063,0.227V256.555z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1026_",
    style: {
      fill: "#FAFAFA"
    },
    d: "M227.429,253.507c0,0.101-0.021,0.202-0.061,0.299 c-0.042,0.098-0.091,0.164-0.149,0.197l-0.594,0.343c-0.057,0.032-0.106,0.024-0.149-0.026 c-0.042-0.049-0.062-0.125-0.062-0.227v-3.528c0-0.555-0.072-0.958-0.219-1.207c-0.146-0.249-0.369-0.287-0.672-0.112 c-0.276,0.159-0.493,0.452-0.652,0.876c-0.159,0.425-0.238,0.916-0.238,1.471v3.528c0,0.101-0.021,0.202-0.062,0.299 c-0.042,0.098-0.091,0.165-0.149,0.197l-0.593,0.343c-0.057,0.032-0.108,0.024-0.149-0.026 c-0.042-0.049-0.063-0.126-0.063-0.227v-6.472c0-0.101,0.021-0.202,0.063-0.299c0.041-0.098,0.091-0.164,0.149-0.198 l0.593-0.341c0.057-0.034,0.106-0.025,0.149,0.025c0.041,0.049,0.062,0.126,0.062,0.227v0.32 c0.136-0.319,0.294-0.609,0.477-0.872c0.182-0.263,0.398-0.466,0.649-0.61c0.317-0.184,0.583-0.25,0.796-0.197 c0.214,0.053,0.385,0.19,0.515,0.411c0.131,0.221,0.223,0.514,0.278,0.875c0.054,0.362,0.081,0.761,0.081,1.196V253.507z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_641_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_716_",
    style: {
      fill: "#455A64"
    },
    d: "M277.875,224.402l-9.714,5.608l1.505-13.624 c-1.162-0.614-1.902-2.126-1.902-4.296c0-3.869,2.352-8.363,5.254-10.039c2.901-1.675,5.253,0.103,5.253,3.972 c0,2.17-0.74,4.537-1.902,6.493L277.875,224.402z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_715_",
    style: {
      fill: "#37474F"
    },
    points: "277.875,224.402 269.326,219.467 268.161,230.01  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_643_",
    style: {
      fill: "#37474F"
    },
    d: "M273.019,202.051c-1.899,1.096-3.557,3.401-4.48,5.946l7.832,4.522l0-0.002 c1.162-1.956,1.902-4.322,1.902-6.493C278.272,202.155,275.92,200.376,273.019,202.051z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_979_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1560_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1570_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2351_",
    style: {
      fill: "#27DEBF"
    },
    d: "M225.796,156.704c-3.322-1.923-7.912-1.65-12.985,1.279 c-10.139,5.855-18.358,20.092-18.356,31.8c0.001,5.875,2.072,9.994,5.416,11.902c0.87,0.497,5.592,3.244,6.469,3.751 c3.322,1.92,7.91,1.646,12.98-1.281c10.138-5.854,18.356-20.091,18.356-31.8c0-5.851-2.054-9.96-5.373-11.878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2399_",
    style: {
      fill: "#27DEBF"
    },
    d: "M219.317,161.755c-10.138,5.857-18.358,20.092-18.356,31.799 c0.001,11.708,8.221,16.454,18.359,10.6c10.138-5.854,18.367-20.091,18.356-31.8 C237.666,160.648,229.446,155.902,219.317,161.755z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_999_",
    style: {
      fill: "#27DEBF"
    },
    d: "M229.454,187.731v1.336c-2.614,4.462-6.192,8.347-10.136,10.618 c-3.951,2.278-7.521,2.527-10.136,1.073v-2.768c0-5.345,3.629-11.633,8.259-14.313l2.665-1.534 c2.366-1.366,4.659-1.541,6.463-0.497C228.41,182.707,229.454,184.92,229.454,187.731z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1014_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M225.796,156.704l6.507,3.771 c-3.324-1.924-7.914-1.652-12.984,1.278c-6.639,3.837-12.455,11.267-15.679,19.226l-6.507-3.775 c3.224-7.959,9.037-15.389,15.679-19.223C217.885,155.055,222.475,154.781,225.796,156.704z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1016_",
    style: {
      opacity: 0.2
    },
    d: "M206.095,205.293c-1.146-0.662-5.422-3.152-6.226-3.61 c-3.344-1.907-5.416-6.026-5.416-11.9l6.507,3.775C200.964,199.264,202.92,203.317,206.095,205.293z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_995_",
    style: {
      opacity: 0.1
    },
    d: "M197.133,177.205l6.507,3.775c-1.701,4.196-2.679,8.537-2.679,12.574v0.003 l-6.507-3.775C194.454,185.742,195.435,181.398,197.133,177.205z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_738_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_980_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_983_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M217.01,181.521c-0.636,0-1.229-0.153-1.766-0.46 c-1.237-0.715-1.918-2.13-1.918-3.983c0-3.393,2.302-7.382,5.243-9.079v-0.003c1.599-0.927,3.161-1.042,4.407-0.328 c1.237,0.715,1.918,2.13,1.918,3.983c0,3.393-2.302,7.382-5.24,9.079C218.742,181.255,217.844,181.521,217.01,181.521z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_764_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_765_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.569,181.648c-1.804-1.044-4.097-0.869-6.463,0.497l-2.665,1.534 c-4.63,2.68-8.259,8.967-8.259,14.313v2.768c2.614,1.453,6.185,1.205,10.136-1.073c3.943-2.271,7.521-6.156,10.136-10.618 v-1.336C229.454,184.92,228.41,182.707,226.569,181.648z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Plants"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plants_10_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_860_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_864_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_866_",
    style: {
      fill: "#27DEBF"
    },
    d: "M432.154,354.648c0,0,1.328-11.679,7.137-20.743 c5.81-9.064,13.792-14.721,21.24-15.31s13.464,6.263,5.494,10.969c-7.969,4.706-22.128,9.508-28.644,27.108L432.154,354.648z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_865_",
    style: {
      opacity: 0.1
    },
    d: "M432.154,354.648c0,0,1.328-11.679,7.137-20.743 c5.81-9.064,13.792-14.721,21.24-15.31s13.464,6.263,5.494,10.969c-7.969,4.706-22.128,9.508-28.644,27.108L432.154,354.648z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_862_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_863_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M434.338,351.615c-0.027-0.005-0.053-0.012-0.079-0.023 c-0.204-0.082-0.302-0.314-0.219-0.518c7.86-19.357,22.823-27.44,29.637-29.009c0.213-0.051,0.427,0.085,0.477,0.298 c0.049,0.215-0.084,0.428-0.298,0.477c-6.675,1.537-21.342,9.48-29.079,28.533C434.705,351.551,434.519,351.648,434.338,351.615 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_259_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_857_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_858_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_859_",
    style: {
      fill: "#27DEBF"
    },
    d: "M474.124,351.844c-0.674,1.52-2.334,2.312-3.879,2.934 c-1.536,0.616-3.22,1.29-4.054,2.727c-1.681,2.904,1.079,6.986-0.726,9.814c-0.758,1.185-2.166,1.81-3.551,2.058 c-1.151,0.215-2.322,0.214-3.489,0.312c-0.561-0.012-1.117-0.052-1.659-0.129c-1.601-0.232-3.338-0.307-4.805,0.512 c-2.308,1.297-3.017,4.211-4.418,6.458c-1.681,2.69-4.652,4.452-7.774,4.876c-1.037,0.137-2.966,0.324-4.023-0.265 c-0.083-0.046-0.151-0.089-0.218-0.139c-0.007-0.001-0.013-0.01-0.019-0.019c-0.145-0.164-0.327-0.372-0.406-0.485 c-0.02-0.019-0.03-0.043-0.041-0.068c-0.409-1.506,0.259-3.073,0.285-4.628c0.003-0.098,0.004-0.189-0.002-0.282 c-0.064-1.808-0.115-3.606-0.158-5.409c-0.084-3.318-0.122-6.643-0.099-9.965c0.023-2.157-0.237-4.519,0.676-6.551 c1.011-2.235,3.524-2.284,4.474-4.477c0.381-0.874,0.583-1.811,0.951-2.695c1.099-2.592,3.762-4.455,6.58-4.593 c4.387-0.223,8.325,3.329,12.707,3.006c1.135-0.089,2.241-0.434,3.359-0.64c3.554-0.665,7.661,0.346,9.659,3.354 C474.331,348.807,474.735,350.464,474.124,351.844z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_737_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_855_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M434.704,373.519c-0.01-0.002-0.02-0.004-0.03-0.007 c-0.199-0.053-0.318-0.258-0.265-0.458c6.062-22.744,30.026-26.031,35.633-25.626c0.203,0.016,0.361,0.194,0.346,0.4 c-0.015,0.206-0.194,0.361-0.4,0.346c-5.484-0.396-28.924,2.82-34.856,25.073C435.082,373.437,434.894,373.554,434.704,373.519z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_733_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_736_",
    style: {
      fill: "#FFFFFF"
    },
    d: "M461.33,361.994c-0.073-0.013-0.142-0.048-0.198-0.105 c-0.06-0.061-6.172-6.086-16.308-4.594c-0.204,0.027-0.395-0.111-0.425-0.316c-0.03-0.205,0.112-0.395,0.316-0.425 c10.528-1.548,16.886,4.744,16.95,4.808c0.145,0.147,0.144,0.384-0.003,0.529C461.571,361.981,461.446,362.015,461.33,361.994z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Clouds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clouds_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1526_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M377.115,80.006l3.182,1.224v-7.011c0-5.558,4.433-6.89,9.246-4.112l0,0 c4.813,2.779,8.715,9.537,8.715,15.095v1.018c1.092-0.436,2.502-0.267,4.044,0.624h0c3.464,2,6.271,6.863,6.271,10.862v0.463 l4.437,2.562c2.281,1.317,4.13,4.52,4.13,7.153c0,2.634-1.849,3.701-4.13,2.384l-35.897-20.725 c-2.281-1.317-4.13-4.519-4.13-7.153C372.985,79.756,374.834,78.689,377.115,80.006z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1523_",
    style: {
      fill: "#E6E6E6"
    },
    d: "M419.706,74.464l5.769,3.331c-0.029-0.258-0.049-0.513-0.049-0.764V75.36 c0-2.974,2.088-4.18,4.664-2.693c1.043,0.602,2.003,1.557,2.78,2.673c0.422-3.74,3.356-5.133,6.92-3.075 c3.854,2.225,6.978,7.636,6.978,12.085v2.501c0,1.153-0.213,2.123-0.591,2.897l4.792,2.767c1.429,0.825,2.587,2.831,2.587,4.481 c0,1.65-1.158,2.319-2.587,1.494l-31.264-18.05c-1.429-0.825-2.587-2.831-2.587-4.481 C417.119,74.308,418.277,73.639,419.706,74.464z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character_3_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_729_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1087_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1144_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M397.368,226.232c-4.2,7.101-8.241,13.27-11.078,16.227 c-5.387,2.506-18.045,6.358-22.998,7.003c-0.878,0.114-1.76-0.11-2.486-0.585c-1.947-1.276-3.453-1.483-5.506-2.194 c-1.607-0.556-2.288-1.324-2.59-1.032c-0.388,0.375-0.811,1.442,0.168,2.547c0.492,0.555,1.389,1.162,2.544,1.903 c0,0-3.541,0.945-6.704,0.115c-4.287-1.125-6.311,0.936-3.412,5.591c1.038,1.667,5.126,4.336,13.41,3.615 c2.387-0.207,5.831-0.407,8.802-1.041c7.946-1.696,16.778-3.339,22.208-4.961c1.37-0.409,3.817-1.994,5.274-3.655 c9.134-10.412,12.159-17.83,16.163-24.572l-0.346-11.017C404.344,213.975,400.882,220.289,397.368,226.232z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1143_",
    style: {
      fill: "#455A64"
    },
    d: "M411.934,213.975c0,0-5.653-1.202-9.902,4.234 c-4.446,5.689-12.307,19.352-12.307,19.352s2.579,6.851,9.518,7.977l11.148-15.058 C410.391,230.48,415.67,220.057,411.934,213.975z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1136_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1142_",
    x: 428.769,
    y: 367.536,
    style: {
      fill: "#FFA8A7"
    },
    width: 7.267,
    height: 12.958
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1141_",
    style: {
      fill: "#FFA8A7"
    },
    points: "410.839,366.845 403.576,367.105 403.212,353.392 410.839,353.132  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1140_",
    style: {
      fill: "#37474F"
    },
    d: "M437.06,255.347c0,7.228-1.064,65.398-1.064,65.398 c0.169,2.08,2.041,5.915,1.636,13.903c-0.551,10.852-1.285,39.368-1.285,39.368s-3.528,2.147-8.092,0.166 c0,0-5.892-39.961-7.194-50.714c-1.136-9.385-4.047-40.52-4.047-40.52l-3.939,36.741c0,0,1.34,5.597,0.901,12.029 c-0.34,4.974-2.677,30.879-2.677,30.879s-3.421,2.418-8.391,0.669c0,0-4.134-39.013-4.218-43.577 c-0.096-5.203,2.417-64.419,2.417-64.419L437.06,255.347z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1139_",
    style: {
      fill: "#263238"
    },
    d: "M428.769,376.758v-1.082c-0.695,0.315-2.311,6.736-5.195,9.475 c-2.292,2.178-5.419,4.693-6.215,7.121c-0.827,2.525,4.355,3.919,6.496,3.524c2.488-0.459,6.802-2.284,7.884-3.976 c1.083-1.692,1.59-4.188,2.469-5.427c0.88-1.24,2.908-2.624,3.384-4.059c0.261-0.788-0.049-2.515-0.416-3.973 c-0.337-1.338-0.702-2.81-1.141-2.684c-0.001,0.163,0,0.825,0,0.825c-0.528,0.609-1.987,1.213-3.633,1.279 C431.34,377.822,428.76,377.602,428.769,376.758z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1138_",
    style: {
      fill: "#263238"
    },
    d: "M403.499,364.771c-0.378,0.014-0.685,0.568-1.517,1.507 c-1.006,1.134-2.651,2.357-4.275,3.204c-2.721,1.419-8.012,3.601-10.406,4.725c-1.496,0.702-1.426,2.584,0.12,3.655 s5.279,1.843,9.762,0.798c2.442-0.569,5.621-2.918,7.633-2.791c2.012,0.127,5.777,0.097,7.262-0.97 c1.485-1.066,0.891-3.343,0.471-5.3c-0.458-2.136-1.031-5.466-1.71-5.32v0.736c-0.874,1.378-5.383,1.939-7.302,0.924 L403.499,364.771z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1137_",
    style: {
      fill: "#263238"
    },
    d: "M417.015,282.947c0,0-5.809-1.704-10.12-6.044c0,0,1.953,3.808,7.76,7.352 l-1.242,32.811L417.015,282.947z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1122_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1124_",
    style: {
      fill: "#27DEBF"
    },
    d: "M432.991,215.059c0,0,5.975,1.383,5.571,12.217l-1.257,17.258l0.035,25.899 c-5.344,6.055-29.036,5.612-37.147-0.485c0,0,0.919-30.65,1.467-42.444c0.389-8.385,2.319-12.606,10.559-13.53l10.134,0.446 L432.991,215.059z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1094_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1116_",
    style: {
      fill: "#263238"
    },
    d: "M425.355,192.535c0,6.224-4.844,11.269-10.819,11.269 c-5.975,0-9.512-5.184-10.819-11.269c-2.392-11.129,4.844-11.269,10.819-11.269 C420.511,181.266,425.355,186.311,425.355,192.535z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1102_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1115_",
    style: {
      fill: "#263238"
    },
    d: "M430.875,197.094c0,0-1.659,8.12-2.325,9.454 c-0.665,1.334-2.041,1.713-2.041,1.713l0.116-5.712L430.875,197.094z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1108_",
    style: {
      fill: "#263238"
    },
    d: "M428.793,185.461c0,0,1.19-0.298,2.454,1.677 c1.084,1.693,1.33,5.496-0.371,9.956l-3.126,0.374L428.793,185.461z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1330_",
    style: {
      fill: "#263238"
    },
    d: "M429.943,187.105l3.833,0.071c0.094-1.1-0.688-2.007-1.747-2.027 C430.971,185.13,430.037,186.005,429.943,187.105z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1286_",
    style: {
      fill: "#263238"
    },
    d: "M430.412,186.197l2.84-2.731c-0.701-0.812-1.905-0.859-2.689-0.105 C429.779,184.114,429.711,185.384,430.412,186.197z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1107_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M426.812,197.47c0.627,0.39,1.521-0.864,2.294-1.707 c0.773-0.842,3.2-1.638,4.459,1.125c1.283,2.815-0.886,5.492-2.69,6.389c-3.225,1.603-4.25-0.728-4.25-0.728l-0.261,12.862 c-4.545,7.03-14.84,6.777-11.139-0.34l0.01-3.915c0,0-3.102,0.49-4.615,0.247c-2.518-0.405-4.102-2.474-4.866-5.313 c-1.227-4.559-1.693-8.241-0.652-17.207c1.141-9.828,12.116-9.93,18.042-6.045C429.072,186.724,426.812,197.47,426.812,197.47 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1106_",
    style: {
      fill: "#263238"
    },
    d: "M413.131,187.349c2.622-0.262,5.214-0.795,7.841-0.989 c0.569-0.042,1.15-0.067,1.701,0.082c2.013,0.544,1.753,2.884,2.073,4.519c0.55,2.815,1.007,7.587,2.066,7.608 c0.315,0.006,1.514-2.065,2.294-2.805c0.505-0.479,0.591-1.512,0.7-2.151c0.2-1.167,0.308-2.35,0.397-3.529 c0.076-0.998,0.176-2.014,0.172-3.016c-0.005-1.124,0.017-2.268-0.262-3.366c-0.254-0.997-0.72-1.743-1.402-2.52 c-0.066-0.075-0.133-0.149-0.2-0.222c-1.293-1.394-2.942-2.439-4.693-3.161c-2.513-1.036-5.236-1.449-7.94-1.726 c-2.704-0.277-5.429-0.427-8.092-0.975c-0.155-0.032-0.321-0.064-0.469-0.008c-0.232,0.089-0.333,0.358-0.38,0.601 c-0.235,1.234,0.32,2.584,1.357,3.295c-1.812,0.144-3.892-0.8-5.638-1.273c-0.294-0.08-0.628-0.155-0.889,0.003 c-0.18,0.109-0.286,0.309-0.35,0.509c-0.148,0.464-0.115,0.965-0.049,1.448c0.195,1.427,0.681,2.837,1.561,3.977 c1.266,1.641,3.35,3.121,5.405,3.533C409.957,187.51,411.472,187.514,413.131,187.349z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1103_",
    style: {
      fill: "#F28F8F"
    },
    d: "M415.235,211.157c0,0,5.62-1.179,7.585-2.267 c1.315-0.728,2.398-1.99,2.716-2.799c0,0-0.368,1.737-1.543,3.301c-1.437,1.913-8.758,3.322-8.758,3.322L415.235,211.157z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1095_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1101_",
    style: {
      fill: "#263238"
    },
    d: "M416.586,196.007c0,0.673,0.505,1.217,1.126,1.216 c0.622-0.002,1.126-0.549,1.126-1.222c0-0.673-0.504-1.217-1.126-1.216C417.091,194.787,416.586,195.334,416.586,196.007z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1100_",
    style: {
      fill: "#263238"
    },
    d: "M418.395,191.15l2.41,1.385c0.355-0.721,0.104-1.616-0.562-1.998 C419.577,190.155,418.75,190.429,418.395,191.15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1099_",
    style: {
      fill: "#F28F8F"
    },
    d: "M415.744,204.11l-2.571,1.005c0.254,0.768,1.036,1.165,1.746,0.887 C415.63,205.725,415.999,204.878,415.744,204.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1098_",
    style: {
      fill: "#263238"
    },
    d: "M406.254,192.182l2.197-1.762c-0.448-0.655-1.303-0.792-1.91-0.305 C405.935,190.601,405.806,191.527,406.254,192.182z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1097_",
    style: {
      fill: "#263238"
    },
    d: "M407.219,195.673c0,0.673,0.504,1.217,1.126,1.215 c0.622-0.002,1.126-0.549,1.126-1.222c0-0.673-0.504-1.217-1.126-1.216C407.723,194.453,407.219,195,407.219,195.673z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1096_",
    style: {
      fill: "#F28F8F"
    },
    points: "413.246,194.731 413.115,201.845 409.078,200.919  "
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_931_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_975_"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_861_",
    style: {
      fill: "#27DEBF"
    },
    points: "317.314,254.276 323.578,250.66 326.061,247.653 319.797,251.27  317.314,254.276  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_934_",
    style: {
      opacity: 0.4
    },
    points: "317.314,254.276 323.578,250.66 326.061,247.653 319.797,251.27  317.314,254.276  "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_936_"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_974_",
    style: {
      fill: "#27DEBF"
    },
    points: "334.361,264.118 340.625,260.502 345.861,255.868 339.596,259.484  334.361,264.118  "
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_935_",
    style: {
      opacity: 0.4
    },
    points: "334.361,264.118 340.625,260.502 345.861,255.868 339.596,259.484  334.361,264.118  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_971_",
    style: {
      fill: "#27DEBF"
    },
    d: "M387.623,276.615c1.373,1.747,2.375,4.314,2.59,6.817 C388.839,281.685,387.838,279.118,387.623,276.615z M402.186,276.804c-2.107-14.352-9.818-28.549-19.009-33.854 c-4.41-2.55-8.492-2.642-11.761-0.73c-0.956,0.555-4.503,2.601-5.901,3.403c-0.113,0.062-0.226,0.123-0.329,0.195 c-0.257,0.144-0.514,0.308-0.761,0.483c-0.473,0.329-0.925,0.699-1.357,1.121c-0.062,0.051-0.124,0.123-0.195,0.185 c-0.185,0.185-0.37,0.391-0.545,0.596c-0.216,0.247-0.432,0.504-0.627,0.771c-0.411,0.545-0.802,1.131-1.151,1.768 c-0.175,0.308-0.35,0.637-0.514,0.977l-51.516-29.741l-6.261,3.608v3.989l0.534,0.308l0.494,0.288v0.843l-1.028,0.596v2.323 l7.566,16.017l7.484,4.328l2.488-3.012l6.6,3.948l3.793,6.497l4.174,2.406l5.233-4.636l6.425,3.711l2.159,8.903l10.764,6.21 c0.545,2.282,1.234,4.513,2.036,6.693c0.072,0.226,0.154,0.452,0.247,0.699c3.578,9.407,9.273,17.456,15.688,21.167 c0.823,0.473,1.624,0.864,2.416,1.162c0.453,0.185,0.905,0.329,1.347,0.452c0.401,0.113,0.802,0.206,1.203,0.267 c1.326,0.236,2.611,0.226,3.814-0.01c0.175-0.041,0.35-0.082,0.524-0.123c0.247-0.051,0.493-0.123,0.73-0.216 c0.185-0.072,0.37-0.144,0.555-0.216c0.195-0.072,0.391-0.165,0.576-0.267c0.185-0.082,0.36-0.175,0.535-0.278 c0.092-0.051,0.185-0.103,0.267-0.154c0.041-0.01,0.082-0.041,0.124-0.072c1.429-0.822,4.955-2.858,5.911-3.403 c4.76-2.755,7.844-9.736,7.844-19.605C402.761,281.893,402.566,279.344,402.186,276.804z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1041_",
    style: {
      fill: "#27DEBF"
    },
    d: "M385.786,288.721c-2.471-1.427-4.475-5.668-4.475-9.473s2.004-5.733,4.475-4.306 c2.471,1.427,4.475,5.668,4.475,9.473C390.26,288.22,388.257,290.148,385.786,288.721z M395.925,280.413 c-2.107-14.341-9.818-28.539-19.009-33.843c-4.256-2.457-8.193-2.642-11.401-0.946c-0.113,0.062-0.226,0.123-0.329,0.195 c-0.257,0.144-0.514,0.308-0.761,0.483c-0.473,0.329-0.925,0.699-1.357,1.121c-0.062,0.051-0.124,0.123-0.195,0.185 c-0.185,0.185-0.37,0.391-0.545,0.596c-0.216,0.247-0.432,0.504-0.627,0.771c-0.411,0.545-0.802,1.131-1.151,1.768 c-0.175,0.308-0.35,0.637-0.514,0.977c-0.853,1.748-1.532,3.783-1.984,6.086l-55.792-32.219v3.989l0.534,0.308l0.494,0.288v0.843 l-1.028,0.596v2.323l7.566,16.017l7.484,4.328l2.488-3.012l6.6,3.948l3.793,6.497l4.174,2.406l5.233-4.636l6.425,3.711 l2.159,8.903l10.764,6.21c0.545,2.282,1.234,4.513,2.036,6.693c0.072,0.226,0.154,0.452,0.247,0.699 c3.578,9.407,9.273,17.456,15.688,21.167c0.823,0.473,1.624,0.864,2.416,1.162c0.453,0.185,0.905,0.329,1.347,0.452 c0.401,0.113,0.802,0.206,1.203,0.267c1.326,0.236,2.611,0.226,3.814-0.01c0.175-0.041,0.35-0.082,0.524-0.123 c0.247-0.051,0.493-0.123,0.73-0.216c0.185-0.072,0.37-0.144,0.555-0.216c0.195-0.072,0.391-0.165,0.576-0.267 c0.185-0.082,0.36-0.175,0.535-0.278c0.092-0.051,0.185-0.103,0.267-0.154c0.041-0.01,0.082-0.041,0.124-0.072 c4.564-2.878,7.495-9.756,7.495-19.389C396.501,285.512,396.295,282.962,395.925,280.413z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1044_",
    style: {
      opacity: 0.4
    },
    d: "M390.26,284.412c0,3.804-2.005,5.737-4.472,4.308 c-2.478-1.429-4.482-5.665-4.482-9.468s2.005-5.736,4.482-4.307c0.658,0.38,1.285,0.956,1.83,1.676 c0.216,2.498,1.223,5.068,2.591,6.816C390.25,283.764,390.26,284.093,390.26,284.412z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1047_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M402.761,284.402c0,9.869-3.084,16.85-7.844,19.605 c-0.956,0.545-4.482,2.58-5.911,3.403c4.564-2.878,7.495-9.756,7.495-19.389c0-2.508-0.206-5.058-0.576-7.607 c-2.107-14.341-9.818-28.539-19.009-33.843c-4.256-2.457-8.193-2.642-11.401-0.946c1.398-0.802,4.945-2.848,5.901-3.403 c3.269-1.912,7.351-1.82,11.761,0.73c9.191,5.305,16.901,19.502,19.009,33.854C402.566,279.344,402.761,281.893,402.761,284.402z "
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_722_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_727_",
    style: {
      fill: "#27DEBF"
    },
    d: "M396.501,288.02c0,9.633-2.93,16.511-7.495,19.389 c1.429-0.822,4.955-2.858,5.911-3.403c4.76-2.755,7.844-9.736,7.844-19.605c0-0.364-0.013-0.731-0.021-1.097 c-2.151,1.242-4.326,2.497-6.262,3.615C396.487,287.287,396.501,287.655,396.501,288.02z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_653_",
    style: {
      opacity: 0.1
    },
    d: "M396.501,288.02c0,9.633-2.93,16.511-7.495,19.389 c1.429-0.822,4.955-2.858,5.911-3.403c4.76-2.755,7.844-9.736,7.844-19.605c0-0.364-0.013-0.731-0.021-1.097 c-2.151,1.242-4.326,2.497-6.262,3.615C396.487,287.287,396.501,287.655,396.501,288.02z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_724_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1050_",
    style: {
      opacity: 0.15
    },
    points: "358.278,261.918 358.278,263.954 302.26,231.611 303.288,231.015  303.288,230.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_1046_",
    style: {
      opacity: 0.15
    },
    points: "358.278,262.761 358.278,263.954 302.26,231.611 303.288,231.015  303.288,231.005  "
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_1030_",
    transform: "matrix(0.956 -0.2934 0.2934 0.956 -64.6042 122.7807)",
    style: {
      opacity: 0.15,
      fill: "none",
      stroke: "#000000",
      strokeMiterlimit: 10
    },
    cx: 376.915,
    cy: 276.71,
    rx: 14.791,
    ry: 27.678
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1045_",
    style: {
      opacity: 0.4,
      fill: "#FFFFFF"
    },
    d: "M360.036,251.72c-0.853,1.748-1.532,3.783-1.984,6.086 l-55.792-32.219l6.261-3.608L360.036,251.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_867_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1093_",
    style: {
      fill: "#FFA8A7"
    },
    d: "M432.506,254.853c2.926-5.533,6.261-17.953,7.922-24.221 c2.359-8.903-1.459-14.505-5.793-14.73c-2.718,0.414-11.642,32.889-11.642,32.889c-0.989,0.791-14.572,7.674-18.936,9.404 c-0.773,0.307-1.634,0.294-2.416,0.009c-2.096-0.765-3.523-0.62-5.574-0.826c-1.606-0.161-2.419-0.732-2.622-0.388 c-0.26,0.442-0.381,1.545,0.788,2.367c0.588,0.414,1.559,0.783,2.798,1.222c0,0-2.32,0.804-5.415,0.736 c-4.195-0.093-5.705,1.73-2.451,5.982c2.039,2.664,5.317,3.504,12.7,0.951c2.127-0.736,5.009-2.166,7.691-3.14 c5.546-2.015,6.97-2.233,11.227-3.666C426.926,259.373,431.207,257.308,432.506,254.853z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_335_",
    style: {
      fill: "#455A64"
    },
    d: "M432.991,215.059c2.552,0.349,5.026,0.926,6.51,2.988 c1.484,2.062,2.721,4.97,1.237,12.958c-1.484,7.988-4.537,16.474-4.537,16.474s-5.936,2.537-12.251-3.899l4.336-16.779 C428.285,226.801,429.028,215.901,432.991,215.059z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserLoginImage);
export default __webpack_public_path__ + "static/media/userLogin_image.8bdda09c8baac0f34fc9c4b630142c67.svg";
export { ForwardRef as ReactComponent };